import React from "react";
import '../style/Contact.css';
import BuyMeCoffeeButton from '../components/BuyMeCoffeeButton';
import Newsletter from '../components/Newsletter';

const Contact = () => {
    return (
        <div className="contact-container">
            {/* Use the shared page header classes */}
            <div className="page-header">
                <h1 className="page-title">Get in touch</h1>
                {/* <img
                    src="/picky-kitty/tools.png"
                    alt="The Picky Kitty Contact"
                    className="header-image"
                /> */}
            </div>

            <p>
                Got questions, feedback, partnership ideas, or just want to send some purrs our way?
                We'd love to hear from you! Drop us a message at{" "}
                <a href="mailto:meow@thepickykitty.com">meow@thepickykitty.com</a> and we'll get back to you faster than a cat chasing a laser pointer.
            </p>

            <p>
                If you enjoy this site and want to support The Picky Kitty's mission to help kitties everywhere find their purr-fect food,
                consider sending a small one-time treat via{" "}
                <a href="https://www.buymeacoffee.com/thepickykitty" target="_blank" rel="noopener noreferrer">Buy Me A Coffee</a>.
                Your support helps keep the website running and helps keep our own kitties full and happy!
            </p>

            <Newsletter />
        </div>
    );
};

export default Contact;
